import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-card-form',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './card-form.component.html',
  styleUrl: './card-form.component.scss',
})
export class CardFormComponent {
  @Input() cardTitle: string = '';
  @Input() showCardTitle: boolean = true;
  @Input() noBorder: boolean = false;
  @Input() noPadding: boolean = false;
  @Input() noMarginBottom: boolean = false;
  @Input() createButtonLabel: string = 'cardForm.create';
  @Input() editButtonLabel: string = 'cardForm.save';
  @Input() mode: 'show' | 'edit' | 'create' = 'show'; // 'show' est le mode par défaut
  @Input() hasRole: boolean = true;
  @Input() isSaving: boolean = false;
  @Input() useSmallButtons: boolean = true;
  @Input() addCancelOnShowMode: boolean = false;
  @Input() addDeleteButton: boolean = false;
  @Input() isDefaultItem: boolean = false;
  @Input() displayMode: 'card' | 'modal' = 'card';
  @Input() showClose: boolean = true;
  @Input() readOnly: boolean = false;
  @Input() showButtons: boolean = true;
  @Input() centerCreateButton: boolean = false;
  @Input() hideCancelInCreateMode: boolean = false;
  @Input() hideCancelButton: boolean = false;
  @Input() testId?: string; // Attribut data-testid optionnel pour les tests

  @Output() toggleEditMode = new EventEmitter<void>();
  @Output() editItem = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();
  @Output() createItem = new EventEmitter<void>();
  @Output() deleteItem = new EventEmitter<void>();
  @Output() dismissModal = new EventEmitter<void>();

  constructor(public translate: TranslateService) {}

  get isShowMode(): boolean {
    return this.mode === 'show';
  }

  get isEditMode(): boolean {
    return this.mode === 'edit';
  }

  get isCreateMode(): boolean {
    return this.mode === 'create';
  }
}
